import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBorderBtn from "../../components/atoms/button/mainBorderBtn";

import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdDisplay01 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay01";
import { errorHandler } from "../../util/errorHandler";
import MemberApi from "../../api/member.api";
import {
  formatNumberWithCommas,
  formatPhoneNumber,
} from "../../util/formatNumber";
import { fileUrl } from "../../api/api";
import { getPaymentInfo } from "../../util/paymentInfoStorage";
import Loading from "../../components/templates/loading";

const LecturePaymentFail = () => {
  const location = useLocation();

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const [searchParams] = useSearchParams();

  const { lectureInfo, localData } = getPaymentInfo(location.state);
  const [myInfo, setMyInfo] = useState({});
  const categoryType =
    lectureInfo?.lectureCategory?.lectureCategoryType ??
    lectureInfo?.lectureCategoryType;
  const isConsulting = Boolean(localData?.consultingMerchId);
  const isSubscription = Boolean(
    lectureInfo?.image &&
    !localData?.lectureVideoId &&
    !localData?.consultingMerchId,
  );
  const isValidFailureSource = Boolean(
    (location.state?.paymentError || searchParams.get("code")) &&
    lectureInfo &&
    localData,
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      navigate(route.login, { replace: true });
      return;
    }

    if (!isValidFailureSource) {
      navigate(route.lecture_list, { replace: true });
      return;
    }

    myInfoData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const myInfoData = async () => {
    try {
      const myInfoRP = (await MemberApi.getMyInfo()).data.data.content;
      sessionStorage.setItem("membership", myInfoRP.membership);
      setMyInfo(myInfoRP);
    } catch (error) {
      errorHandler(error);
    }
  };

  const retryPayment = () => {
    if (isSubscription) {
      navigate(route.my_page_payment_subscribe, { replace: true });
    } else if (isConsulting) {
      navigate(`${route.consulting_payment}/${localData.consultingMerchId}`, {
        replace: true,
      });
    } else {
      navigate(`${route.lecture_payment}/${localData.lectureVideoId}`, {
        replace: true,
      });
    }
  };

  const goToProductList = () => {
    if (isSubscription) {
      navigate(route.my_page_payment, { replace: true });
    } else if (isConsulting) {
      navigate(route.consulting, { replace: true });
    } else {
      navigate(
        categoryType === "FINANCE_STUDY"
          ? route.study_list
          : route.lecture_list,
        { replace: true },
      );
    }
  };

  if (!isValidFailureSource) return <Loading />;

  return (
    <>
      <LecturePaymentFailSection>
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isSmall ? "20px 20px 80px 20px" : "80px 0px 150px 0px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: isMobile ? 40 : 141,
            }}
          >
            <img
              style={{
                width: isMobile ? 40 : 80,
                height: isMobile ? 40 : 80,
                marginBottom: isMobile ? 20 : 20,
              }}
              src="/assets/icons/warning_r.png"
              alt="warning_r"
            />
            <LSBdDisplay02
              style={{
                color: "#000000",
                fontSize: isMobile ? 18 : 24,
                lineHeight: isMobile ? "25.2px" : "33.6px",
              }}
            >
              결제에 실패하였습니다!
            </LSBdDisplay02>
          </div>

          <LSBdH2HeadLine
            style={{
              color: "#5050FF",
              fontSize: isMobile ? 15 : 18,
              lineHeight: isMobile ? "21px" : "25.2px",
            }}
          >
            구매 정보
          </LSBdH2HeadLine>

          <div
            style={{
              marginTop: 16,
              marginBottom: isMobile ? 16 : 30,
              width: "100%",
              height: 1,
              background: "#DBDDE0",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "flex-start" : "center",
            }}
          >
            <img
              src={
                lectureInfo?.thumbnailServerFileName
                  ? `${fileUrl}/${lectureInfo?.thumbnailServerFileName}`
                  : lectureInfo?.image
                    ? lectureInfo?.image
                    : ""
              }
              style={{
                width: isMobile ? "100%" : 175,
                height: isMobile ? 214 : 112,
                marginRight: isMobile ? 0 : 40,
                borderRadius: isMobile ? 10 : 8,
                marginBottom: isMobile ? 20 : 0,
              }}
              alt="video"
            />
            <LSBdDisplay01
              style={{
                flex: 1,
                color: "#000000",
                marginRight: isMobile ? 0 : 90,
                fontSize: isMobile ? 16 : 20,
                lineHeight: isMobile ? "22.4px" : "28px",
                marginBottom: isMobile ? 10 : 0,
              }}
            >
              {lectureInfo?.title}
            </LSBdDisplay01>

            <div
              style={{
                minWidth: isMobile ? "100%" : 260,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TopTextContain $isMobile={isMobile}>
                <TopRightText $isMobile={isMobile}>결제번호</TopRightText>
                <TopLeftText $isMobile={isMobile}>
                  {searchParams.get("paymentKey")
                    ? searchParams.get("paymentKey")
                    : localData?.pgPaymentId}
                </TopLeftText>
              </TopTextContain>
              <TopTextContain $isMobile={isMobile}>
                <TopRightText $isMobile={isMobile}>결제일자</TopRightText>
                <TopLeftText $isMobile={isMobile}>
                  {localData?.date}
                </TopLeftText>
              </TopTextContain>
              <TopTextContain $isMobile={isMobile}>
                <TopRightText $isMobile={isMobile}>결제금액</TopRightText>
                <TopLeftText $isMobile={isMobile}>
                  {formatNumberWithCommas(localData?.realPay)}원
                </TopLeftText>
              </TopTextContain>
              <TopTextContain $isMobile={isMobile}>
                <TopRightText $isMobile={isMobile}>결제수단</TopRightText>
                <TopLeftText $isMobile={isMobile}>
                  {localData?.payMethod}
                </TopLeftText>
              </TopTextContain>
              <TopTextContain $isMobile={isMobile}>
                <TopRightText $isMobile={isMobile}>결제상태</TopRightText>
                <TopLeftText $isMobile={isMobile}>결제실패</TopLeftText>
              </TopTextContain>
            </div>
          </div>

          <LSBdH2HeadLine
            style={{
              color: "#5050FF",
              marginTop: isMobile ? 44 : 60,
              fontSize: isMobile ? 15 : 18,
              lineHeight: isMobile ? "21px" : "25.2px",
            }}
          >
            구매자 정보
          </LSBdH2HeadLine>

          <div
            style={{
              marginTop: 16,
              marginBottom: isMobile ? 16 : 30,
              width: "100%",
              height: 1,
              background: "#DBDDE0",
            }}
          />

          <TopTextContain $isMobile={isMobile}>
            <TopRightText $isMobile={isMobile}>구매자</TopRightText>
            <TopLeftText $isMobile={isMobile}>{myInfo?.name}</TopLeftText>
          </TopTextContain>
          <TopTextContain $isMobile={isMobile}>
            <TopRightText $isMobile={isMobile}>전화번호</TopRightText>
            <TopLeftText $isMobile={isMobile}>
              {formatPhoneNumber(myInfo?.phoneNumber)}
            </TopLeftText>
          </TopTextContain>
          <TopTextContain $isMobile={isMobile}>
            <TopRightText $isMobile={isMobile}>이메일</TopRightText>
            <TopLeftText $isMobile={isMobile}>{myInfo?.email}</TopLeftText>
          </TopTextContain>

          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "center",
              marginTop: isMobile ? 40 : 100,
            }}
          >
            <MainBtn
              onClick={retryPayment}
              style={{
                marginRight: isMobile ? 0 : 30,
                width: isMobile ? "100%" : 380,
                marginBottom: isMobile ? 10 : 0,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                다시 결제하기
              </LSRgH1HeadLine>
            </MainBtn>

            <MainBorderBtn
              onClick={goToProductList}
              style={{
                width: isMobile ? "100%" : 380,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#5050FF",
                  textAlign: "center",
                }}
              >
                목록으로 돌아가기
              </LSRgH1HeadLine>
            </MainBorderBtn>
          </div>
        </PCContainer>
      </LecturePaymentFailSection>
    </>
  );
};

export default LecturePaymentFail;

const LecturePaymentFailSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const TopTextContain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => (props.$isMobile ? "6px" : "3px")};
`;

const TopRightText = styled(LSBdBody01)`
  width: ${(props) => (props.$isMobile ? "42px" : "55px")};
  margin-right: ${(props) => (props.$isMobile ? "10px" : "18px")};
  font-size: ${(props) => (props.$isMobile ? "12px" : "14px")};
  line-height: ${(props) => (props.$isMobile ? "14.4px" : "19.6px")};

  color: #898e99;
`;

const TopLeftText = styled(LSRgBody01)`
  font-size: ${(props) => (props.$isMobile ? "12px" : "14px")};
  line-height: ${(props) => (props.$isMobile ? "14.4px" : "19.6px")};

  color: #000000;
`;
